var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 408,
    viewBox: "0 0 488 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9486_8857)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488,
    height: 408,
    fill: "#E8F2F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9486_8857)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_9486_8857)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.666,
    cy: -3.47925,
    rx: 47,
    ry: 46.5,
    transform: "rotate(90 107.666 -3.47925)",
    fill: "#1579BE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_f_9486_8857)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 460,
    cy: 401.521,
    rx: 96.5,
    ry: 96,
    transform: "rotate(90 460 401.521)",
    fill: "#1579BE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_9486_8857)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.433,
    cy: 73.4919,
    rx: 31.6052,
    ry: 79.606,
    transform: "rotate(90 343.433 73.4919)",
    fill: "#4494CB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_9486_8857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.426,
    cy: -243.103,
    r: 121.31,
    transform: "rotate(90 145.426 -243.103)",
    fill: "#73AFD8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter4_f_9486_8857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -3.06485,
    cy: 137.438,
    r: 100.672,
    transform: "rotate(90 -3.06485 137.438)",
    fill: "#1579BE"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 87.0208,
    width: 233,
    height: 233,
    rx: 52,
    fill: "#1579BE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5 240.697V174.74L201.787 187.992V253.948L179.5 240.697Z",
    fill: "#4AC0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5 240.697V174.74L201.787 187.992V253.948L179.5 240.697Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.568 217.507V192.509L243.65 204.255V229.252L222.568 217.507Z",
    fill: "#4AC0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.568 217.507V192.509L243.65 204.255V229.252L222.568 217.507Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.568 265.694V240.697L243.65 253.948V278.645L222.568 265.694Z",
    fill: "#4AC0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.568 265.694V240.697L243.65 253.948V278.645L222.568 265.694Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.638 192.81L243.652 204.255V229.252L265.638 217.808V192.81Z",
    fill: "#3F96D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.638 192.81L243.652 204.255V229.252L265.638 217.808V192.81Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.652 279.247V253.647L286.118 228.048V179.86L308.103 166.307V240.396L243.652 279.247Z",
    fill: "#3F96D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.652 279.247V253.647L286.118 228.048V179.86L308.103 166.307V240.396L243.652 279.247Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65 128.656L191.547 159.978L213.231 173.229L243.65 154.858L286.115 179.855L308.101 166.302L243.65 128.656Z",
    fill: "#2078BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65 128.656L191.547 159.978L213.231 173.229L243.65 154.858L286.115 179.855L308.101 166.302L243.65 128.656Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65 181.06L222.568 192.504L243.65 204.551L265.635 192.806L243.65 181.06Z",
    fill: "#2078BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65 181.06L222.568 192.504L243.65 204.551L265.635 192.806L243.65 181.06Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9486_8857",
    x: -10.174,
    y: -121.819,
    width: 235.68,
    height: 236.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.67,
    result: "effect1_foregroundBlur_9486_8857"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9486_8857",
    x: 292.66,
    y: 233.681,
    width: 334.68,
    height: 335.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.67,
    result: "effect1_foregroundBlur_9486_8857"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_9486_8857",
    x: 62.4817,
    y: -159.458,
    width: 561.902,
    height: 465.899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100.672,
    result: "effect1_foregroundBlur_9486_8857"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_9486_8857",
    x: -378.574,
    y: -767.102,
    width: 1048,
    height: 1048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 201.345,
    result: "effect1_foregroundBlur_9486_8857"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_9486_8857",
    x: -175.076,
    y: -34.5739,
    width: 344.024,
    height: 344.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.67,
    result: "effect1_foregroundBlur_9486_8857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9486_8857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488,
    height: 408,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9486_8857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 488,
    fill: "white",
    transform: "translate(488 0.020752) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/Icon_Light.cf301190cd623ed2af2afaa8a0471b7e.svg";
export { ForwardRef as ReactComponent };